import { createRefPath, createRefPath_client } from '../appData/appRefPaths';
import { _fcmCollectionName, _profileCollectionName, _useFcmCollection } from "./getProfile";

/**
 * profileData = {email, _itemKey}
 * @param {object} fcmTokens 
 * @param {object} profileData 
 * @param {object} pathViews 
 * @param {function} callback 
 * @returns 
 */
export const updateAppUserFcmTokenToDatabase = async (isSmartPhone, database_fns, fcmTokens, profileData, pathViews, callback) => {
  if (profileData) {
    return updateProfileToken(isSmartPhone, database_fns, fcmTokens, profileData, pathViews, callback)
  }
}

/** Updates a profile token for the user */
const updateProfileToken = async (isSmartPhone, database_fns, fcmTokens, profileData, pathViews, callback) => {

  const { email, _itemKey } = profileData ?? {}

  const allowStandAlone = true
  let result;

  if (isSmartPhone || allowStandAlone) {

    if (_useFcmCollection) {
      const _refPath_fcm = createRefPath([_fcmCollectionName, _itemKey]) // profiles/profileId
      // const xxx = await database_fns.
      // const xxx = await database_fns.update_doc(_refPath_fcm, { fcmTokens: fcmTokens })
      const xxx = await database_fns.update_docc({
        refPath: _refPath_fcm,
        data: { fcmTokens: fcmTokens },
      })
      console.log('xxx', xxx)
    }

    if (_itemKey) {
      const profile = await database_fns.get_data({ refPath: [_profileCollectionName, _itemKey], opts: { returnFirstObject: true } }) // profiles/_itemKey
      if (profile) {
        const { fcmTokens: fcmTokens_p } = profile
        const _fcmTokens = fcmTokens_p ? { ...fcmTokens_p, ...fcmTokens } : fcmTokens
        const _refPath = createRefPath([_profileCollectionName, profile.id])
        result = await database_fns.update_docc({
          refPath: _refPath,
          data: { fcmTokens: _fcmTokens },
        })
        return result
      }
    }

    if (email) {
      result = await updateClientProfileToken(database_fns, fcmTokens, email, pathViews)
      return result
    }
  } else {
    return;
  }
}

const updateClientProfileToken = async (database_fns, fcmTokens, email, pathViews) => {

  if (email) {
    const _refPath = createRefPath_client(pathViews, [_profileCollectionName, email])
    try {
      // const result = await database_fns.update_doc(_refPath, { fcmTokens: fcmTokens })
      const result = await database_fns.update_docc({
        refPath: _refPath,
        data: { fcmTokens: fcmTokens },
      })
      return result
    } catch (error) {
      console.log('Client token NOT updated ', error)
    }
  }
} 